import { FreshAsphalt, SpbSky0 } from './palette';

export const headerLogoLabelColor = FreshAsphalt;
export const headerLinkColor = FreshAsphalt;
export const headerLinkOpacity = '0.6';
export const headerHelpTipsContainerColor = SpbSky0;
